import { useState } from 'react'
import { View, Text, Alert } from 'react-native'
import { useTranslation } from 'react-i18next'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../lib/AuthContext'
import { Msg, StyledInput } from '../../components/Leagues/ui'
import Ionicons from '@expo/vector-icons/Ionicons'
import GradientButton from '../../components/GradientButton'
import Sheet from './Sheet'
import { useThemeColors } from '../../lib/useThemeColors'
import { StyleSheet } from 'react-native'
import { colors, fonts } from '../../lib/theme'

export default function ModaleUniscitiLega({ visible, userId, onClose, onSuccess }) {
  const { t } = useTranslation()
  const { competitionId } = useAuth()
  const tc = useThemeColors()
  const [search, setSearch]       = useState('')
  const [results, setResults]     = useState([])
  const [loading, setLoading]     = useState(false)
  const [joining, setJoining]     = useState(null)
  const [passReq, setPassReq]     = useState(null)
  const [passInput, setPassInput] = useState('')

  const handleSearch = async () => {
    if (search.length < 2) return
    setLoading(true)
    const { data } = await supabase.from('view_league_public').select('id_league, name, is_public').eq('id_competition', competitionId).ilike('name', `%${search}%`).limit(8)
    setResults(data ?? [])
    setLoading(false)
  }

  const join = async (league) => {
    if (!league.is_public && passReq?.id_league !== league.id_league) { setPassReq(league); return }
    setJoining(league.id_league)
    const { data, error } = await supabase.rpc('fn_join_league', {
      p_id_user: userId, p_id_league: league.id_league,
      p_password: league.is_public ? null : passInput,
    })
    if (error || !data?.[0]?.success) Alert.alert('Error', data?.[0]?.message ?? t('league.err_join'))
    else onSuccess()
    setJoining(null)
  }

  return (
    <Sheet visible={visible} title={t('league.join_title')} onClose={onClose}>
      <View style={{ flexDirection: 'row', gap: 8, marginBottom: 16 }}>
        <View style={{ flex: 1 }}>
          <StyledInput value={search} onChangeText={setSearch} placeholder={t('league.search_placeholder')} onSubmitEditing={handleSearch} style={{ marginBottom: 0 }} />
        </View>
        <GradientButton onPress={handleSearch} loading={loading} size="md">{t('league.search')}</GradientButton>
      </View>
      {results.length === 0 && search.length >= 2 && !loading && (
        <Text style={{ color: tc.textMuted, fontSize: 13, textAlign: 'center', padding: 20 }}>{t('league.no_leagues_found')}</Text>
      )}
      {results.map(l => (
        <View key={l.id_league} style={[styles.leagueSearchRow, { backgroundColor: tc.bgCard2, borderColor: tc.border }]}>
          <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Text style={[styles.leagueSearchName, { color: tc.text }]}>{l.name}{!l.is_public && <Ionicons name="lock-closed-outline" size={12} color={tc.textMuted} style={{ marginLeft: 4 }} />}</Text>
            <GradientButton onPress={() => join(l)} loading={joining === l.id_league} size="sm">{t('league.join_btn')}</GradientButton>
          </View>
          {passReq?.id_league === l.id_league && (
            <View style={{ marginTop: 10, gap: 8 }}>
              <Text style={{ fontSize: 12, color: tc.rosaText }}>{t('league.password_insert')}</Text>
              <View style={{ flexDirection: 'row', gap: 8 }}>
                <View style={{ flex: 1 }}>
                  <StyledInput value={passInput} onChangeText={setPassInput} placeholder="Password" secureTextEntry style={{ marginBottom: 0 }} />
                </View>
                <GradientButton onPress={() => join(l)} size="md">OK</GradientButton>
              </View>
            </View>
          )}
        </View>
      ))}
    </Sheet>
  )
}

const styles = StyleSheet.create({
  leagueSearchRow:  { borderRadius: 12, borderWidth: 1, padding: 12, paddingHorizontal: 14, marginBottom: 10 },
  leagueSearchName: { fontSize: 14, fontFamily: fonts.condensedBold },
})